import { actions } from "components/settings/tags/logic/actions";
import { newTagSelector } from "core/dataConstants";
import { createError } from "core/exceptions";
import { createSagasForBasicCall } from "core/sagas";
import { call, put, select, takeLatest } from "redux-saga/effects";
import TagsService from "services/tagsService";

export function* createTag() {
    try {
        const newTag = yield select(newTagSelector);
        const response = yield call(TagsService.create, newTag);
        yield put(
            actions.CREATE_TAG.success({
                data: response,
            })
        );
    } catch (e) {
        yield put(actions.CREATE_TAG.failed(null, createError(e)));
    }
}

export default [...createSagasForBasicCall(actions), takeLatest(actions.CREATE_TAG.sendType, createTag)];
